import React from "react";
import { string, func, bool } from "prop-types";
import { twMerge } from "tailwind-merge";

import Typography from "../shared/Typography";
import CitroenIcon from "../shared/Icons/Citroen";
import FnacDartyIconContainer from "../shared/FnacDartyIconContainer";

import { TEST_DRIVE_TYPE_ID } from "@shared/constants";

const MapFilterItem = ({
  color,
  title,
  type,
  filterEvent,
  isSelected,
  ...props
}) => (
  <li
    className="flex flex-col gap-4 max-w-60 px-2 shrink-0 grow-0 cursor-pointer group"
    onClick={filterEvent}
    {...props}
  >
    {type === TEST_DRIVE_TYPE_ID.FNAC_DARTY ? (
      <div
        className={twMerge(
          "flex flex-row justify-center items-center h-16 transition duration-150 group-hover:scale-105 group-active:scale-95",
          !isSelected && "grayscale"
        )}
        isSelected={isSelected}
      >
        <FnacDartyIconContainer
          dataId={`point-logo-${type}`}
          isOrientationHorizontal={false}
        />
      </div>
    ) : (
      <div
        className={twMerge(
          "grid place-items-center p-2 h-16 min-w-9 rounded-full bg-white self-center shadow-sm transition duration-150 group-hover:scale-105 group-active:scale-95",
          !isSelected && "grayscale opacity-50"
        )}
        style={{ color: `#${color}` }}
      >
        <CitroenIcon />
      </div>
    )}
    <Typography
      className="text-xs/tight text-center font-semibold"
      style={{ color: `#${color}` }}
    >
      {title}
    </Typography>
  </li>
);

MapFilterItem.propTypes = {
  color: string.isRequired,
  isSelected: bool.isRequired,
  title: string.isRequired,
  type: string.isRequired,
  filterEvent: func.isRequired,
};

export default MapFilterItem;
